import { Component } from '@angular/core';

@Component({
    selector: 'footer-links',
    templateUrl: './footer-links-component.html',
})
export class FooterLinksComponent {
}
